import { render, staticRenderFns } from "./referrals-card.vue?vue&type=template&id=35b178d8&scoped=true&"
import script from "./referrals-card.vue?vue&type=script&lang=js&"
export * from "./referrals-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b178d8",
  null
  
)

export default component.exports